import * as React from "react";
import ICategory from "../models/ICategory";

const CategoryContext = React.createContext<{ category: ICategory | undefined; setFn: (categories: ICategory | undefined) => void }>({
    category: undefined,
    setFn: () => {},
});

export default CategoryContext;
